export default __webpack_public_path__ + "images/3R.cdb7769.png";